import React, { useState, useEffect, useMemo, createContext } from 'react';
import PropTypes from 'prop-types';
import BZAPIService from '../services/BZAPIService';
import { initBsaProdSetting } from '../helpers/bsaConfig';

const TenantSettingsContext = createContext({
  bsaEnabled: true,
  bsaProd: true,
  isLoaded: false
});

const TenantSettingsProvider = ({ children }) => {
  const [bsaEnabled, setBsaEnabled] = useState(true);
  const [bsaProd, setBsaProd] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const [bsaEnabledRes, bsaProdRes] = await Promise.allSettled([
        BZAPIService.getTenantSetting('bsaEnabled'),
        BZAPIService.getTenantSetting('bsaProd')
      ]);

      if (cancelled) return;

      if (bsaEnabledRes.status === 'fulfilled') {
        setBsaEnabled(bsaEnabledRes.value?.value?.value !== false);
      } else {
        console.warn('Failed to fetch bsaEnabled setting, defaulting to enabled:', bsaEnabledRes.reason);
      }

      const bsaProdValue = bsaProdRes.status === 'fulfilled' ? bsaProdRes.value?.value?.value !== false : true;
      if (bsaProdRes.status !== 'fulfilled') {
        console.warn('Failed to fetch bsaProd setting, defaulting to prod:', bsaProdRes.reason);
      }
      setBsaProd(bsaProdValue);
      initBsaProdSetting(bsaProdValue);

      setIsLoaded(true);
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => ({ bsaEnabled, bsaProd, isLoaded }), [bsaEnabled, bsaProd, isLoaded]);

  return <TenantSettingsContext.Provider value={value}>{children}</TenantSettingsContext.Provider>;
};

TenantSettingsProvider.propTypes = { children: PropTypes.node };

export { TenantSettingsContext, TenantSettingsProvider };
